/**
 * Campaign status code ↔ label maps.
 * Mirrors the legacy constants in obd_frontend/src/Container/Helpers/constant.js
 * so server payloads continue to round-trip identically.
 */

export const STATUS_PRIORITY = {
  Processing: 0,
  Running: 1,
  Complete: 2,
  Paused: 3,
  Timeout_Paused: 4,
  Ready: 5,
  'Low Balance': 6,
  Error: 7,
  Cancelling: 8,
  Cancelled: 9,
  Pausing: 10,
  Resuming: 11,
  Timeout_Pausing: 12,
  'System Cancelled': 13,
  'System Complete': 14,
} as const;

export const STATUS_MAP = {
  Ready: 0,
  Processing: 21,
  Running: 1,
  Complete: 2,
  'Low Balance': 3,
  Error: [4, 5],
  Cancelling: 6,
  Cancelled: 7,
  Pausing: 8,
  Paused: 9,
  Resuming: 10,
  Timeout_Pausing: 22,
  Timeout_Paused: 23,
  'System Cancelled': 12,
  'System Complete': 11,
} as const;

export type StatusLabel = keyof typeof STATUS_MAP;

export const STATUS_CODE_TO_LABEL: Record<number, StatusLabel> = Object.entries(STATUS_MAP).reduce(
  (acc, [label, code]) => {
    if (Array.isArray(code)) {
      code.forEach((c) => (acc[c] = label as StatusLabel));
    } else {
      acc[code as number] = label as StatusLabel;
    }
    return acc;
  },
  {} as Record<number, StatusLabel>,
);

export type StatusTone = 'success' | 'warning' | 'destructive' | 'neutral' | 'info';

export const STATUS_TONE: Record<StatusLabel, StatusTone> = {
  Ready: 'neutral',
  Processing: 'info',
  Running: 'info',
  Complete: 'success',
  'Low Balance': 'warning',
  Error: 'destructive',
  Cancelling: 'warning',
  Cancelled: 'destructive',
  Pausing: 'warning',
  Paused: 'neutral',
  Resuming: 'info',
  Timeout_Pausing: 'warning',
  Timeout_Paused: 'neutral',
  'System Cancelled': 'destructive',
  'System Complete': 'success',
};
